import { FindCharleeBenefits } from "../../../components/Contents/findcharleepage/FindCharleeBenefits"
import { Footer } from "../../../components/footers/Footer"
import { FooterBanner } from "../../../components/footers/FooterBanner"
import { HomeHeader } from "../../../components/headers/HomeHeader"
import { FindCharleeHero } from "../../../components/heros/FindCharleeHero"
import { PageMain } from "../../../components/seo/PageMain"
import { PageSeoHelmet } from "../../../components/seo/PageSeoHelmet"
import { STATIC_PAGE_SEO_META } from "../../../components/seo/staticPageSeoMeta"
import SplitType from 'split-type'
import gsap, {} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import TextPlugin from "gsap/TextPlugin";
import { useGSAP } from '@gsap/react';
import { useRef } from "react"

export const FindCharlee = () => {
  const findCharleeRef = useRef()

  useGSAP(() => {
    const findCharleeDashboard = gsap.utils.toArray('.findCharlee-dashboard');
    const findCharleeLogo = gsap.utils.toArray('.findCharlee-logo');
    const findCharleeLogoTxt = gsap.utils.toArray('.findCharlee-logoTxt');
    const findCharleeHead = gsap.utils.toArray('.findCharlee-head');
    const findCharleeText = new SplitType('.findCharlee-text-inner', {
      types: 'lines',
      tagName: 'span',
    });
    const findCharleeBook = gsap.utils.toArray('.findCharlee-book');
    const findCharleeFeatures = gsap.utils.toArray('.findCharlee-features');
    const findCharleeTimeline = gsap.timeline();
    findCharleeTimeline.fromTo(findCharleeLogo[0], {opacity: 0, clipPath: 'inset(100%)'}, {opacity: 1, clipPath: 'inset(0%)', duration: 0.5});
    findCharleeTimeline.fromTo(
      findCharleeLogoTxt[0],
      { opacity: 0, y: 12 },
      { opacity: 1, y: 0, duration: 0.7, ease: 'power4.out' },
      '+=0'
    );
    findCharleeTimeline.fromTo(
      findCharleeHead[0],
      { y: '50%', opacity: 0 },
      { y: '0', opacity: 1, duration: 0.9, ease: 'power4.out' },
      "+=0"
    )
    findCharleeTimeline.fromTo(
      findCharleeText.lines,
      {
        y: '-50%',
        opacity: 0
      },
      {
        y: '0',
        opacity: 1,
        stagger: 0.1,
        duration: 0.5,
        ease: 'power4.out',
      },
      "+=0"
    )
    findCharleeTimeline.fromTo(
      findCharleeBook[0],
      {
        opacity: 0,
        clipPath: 'inset(0% 0% 100% 0%)',
      },
      {
        opacity: 1,
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 0.5
      },
      '+=0'
    )
    findCharleeTimeline.fromTo(
      findCharleeFeatures[0],
      { y: '-50%', opacity: 0 },
      { y: '0', opacity: 1, duration: 0.9, ease: 'power4.out' },
      "+=0"
    )
    gsap.fromTo(findCharleeDashboard[0], {opacity: 0, zIndex: 2, x: '-100%'}, {opacity: 1, zIndex: 1, x: '0', duration: 2})
  }, {
    scope: findCharleeRef
  })

  return (
    <>
      <PageSeoHelmet {...STATIC_PAGE_SEO_META.products.findcharlee} />
      <div className="w-full overflow-hidden bg-[#F9F9F9]">
        <HomeHeader headerColor={'#F9F9F9'} textColor={'#021744'} />
        <PageMain ref={findCharleeRef} className="findCharlee-page">
          <FindCharleeHero />
          <FindCharleeBenefits />
        </PageMain>
        <FooterBanner />
        <Footer />
      </div>
    </>
  );
}